export const translations = {
  'INCLUDED': {
    fi: 'Mitä sisältyy hintaan',
    en: 'What is included'
  },
  'LOADING': {
    fi: 'Ladataan...',
    en: 'Loading...'
  },
  'GO_BACK': {
    fi: 'Takaisin',
    en: 'Previous'
  },
  'COULDNT_LOAD': {
    fi: 'Lataus epäonnistui',
    en: 'Failed to load'
  },
  'WHAT_IS_INCLUDED': {
    fi: 'Mitä sisältyy hintaan',
    en: "What's included"
  },
  'WHAT_IS_NOT_INCLUDED': {
    fi: 'Mitä ei sisälly hintaan',
    en: "What's not included"
  },
  'TAKE_NOTICE': {
    fi: 'Huomioithan',
    en: 'Please note'
  },
  'WHAT_SHOULD_I_BRING': {
    fi: 'Mitä minun tulee tuoda mukana',
    en: 'What do I need to bring'
  },
  'BOOKING_RULES': {
    fi: 'Varausehdot',
    en: 'Cancellation policy'
  },
  'CANCELLATION_PART_1': {
    fi: 'Veloitamme',
    en: 'We will charge a cancellation fee of'
  },
  'CANCELLATION_PART_2': {
    fi: 'peruutusmaksun, jos varaus peruutetaan alle',
    en: 'if booking is cancelled'
  },
  'CANCELLATION_PART_3': {
    fi: 'päivää päivä ennen tapahtumaa',
    en: 'days or less before the event'
  },
  'EXPERIENCE_TYPE': {
    fi: 'Elämystyyppi',
    en: 'Experience type'
  },
  'DIFFICULTY': {
    fi: 'Vaikeusaste',
    en: 'Difficulty'
  },
  'BOOKING_IN_ADVANCE': {
    fi: 'Varaus etukäteen',
    en: 'Booking in advance'
  },
  'BOOK_BEFORE_PART_1': {
    fi: 'Varaukset tulee tehdä viimeistään ennen alkamisajankohtaa:',
    en: 'Cut off:'
  },
  'BOOK_BEFORE_PART_2': {
    fi: 'h',
    en: 'h'
  },
  'CATEGORIES': {
    fi: 'Kategoriat',
    en: 'Categories'
  },
  'DURATION': {
    fi: 'Kesto',
    en: 'Duration'
  },
  'LIVE_GUIDE': {
    fi: 'Liveopas',
    en: 'Live tour guide'
  },
  'WRITTEN_LANGUAGES_SUPPORTED': {
    fi: 'Tuetut kirjoitetut kielet',
    en: 'Supported written languages'
  },
  'MEETING_PLACES': {
    fi: 'Tapaamispaikat',
    en: 'Meeting points'
  },
  'TICKETS': {
    fi: 'Liput',
    en: 'Tickets'
  },
  'DATE': {
    fi: 'Päivämäärä',
    en: 'Date'
  },
  'EASY': {
    fi: 'Helppo',
    en: 'Easy'
  },
  'MODERATE': {
    fi: 'Keskitaso',
    en: 'Moderate'
  },
  'HARD': {
    fi: 'Vaikea',
    en: 'Hard'
  },
  'PREVIOUS': {
    fi: 'Edellinen',
    en: 'Previous'
  },
  'NEXT': {
    fi: 'Seuraava',
    en: 'Next'
  },
  'CLOSE': {
    fi: 'Sulje',
    en: 'Close'
  },
  'PICK_A_TIME': {
    fi: 'Valitse aika',
    en: 'Pick a time'
  },
  'CHOOSE_A_PRICE': {
    fi: 'Valitse hinta',
    en: 'Pick a rate'
  },
  'ERROR': {
    fi: 'Virhe',
    en: 'Error'
  },
  'JANUARY': {
    fi: 'Tammikuu',
    en: 'January'
  },
  'FEBRUARY': {
    fi: 'Helmikuu',
    en: 'February'
  },
  'MARCH': {
    fi: 'Maaliskuu',
    en: 'March'
  },
  'APRIL': {
    fi: 'Huhtikuu',
    en: 'April'
  },
  'MAY': {
    fi: 'Toukokuu',
    en: 'May'
  },
  'JUNE': {
    fi: 'Kesäkuu',
    en: 'June'
  },
  'JULY': {
    fi: 'Heinäkuu',
    en: 'July'
  },
  'AUGUST': {
    fi: 'Elokuu',
    en: 'August'
  },
  'SEPTEMBER': {
    fi: 'Syyskuu',
    en: 'September'
  },
  'OCTOBER': {
    fi: 'Lokakuu',
    en: 'October'
  },
  'NOVEMBER': {
    fi: 'Marraskuu',
    en: 'November'
  },
  'DECEMBER': {
    fi: 'Joulukuu',
    en: 'December'
  },
  'DESCRIPTION': {
    fi: 'Kuvaus',
    en: 'Description'
  },
  'PICKUP_PLACES': {
    fi: 'Kuljetus',
    en: 'Pick-up'
  },
  'ITENERARY': {
    fi: 'Ohjelma',
    en: 'Itenerary'
  },
  'PARTICIPANTS': {
    fi: '1. Osallistujat',
    en: '1. Participants'
  },
  'CHOOSE_A_DATE': {
    fi: '2. Valitse päiväys',
    en: '2. Choose a date'
  },
  'SUMMARY': {
    fi: '3. Yhteenveto',
    en: '3. Review summary'
  },
  'ORDER_SUMMARY': {
    fi: 'Varauksen yhteenveto',
    en: 'Reservation summary'
  },
  'QUESTIONS_ABOUT_ORDER': {
    fi: 'Kysymyksiä varauksesta',
    en: 'Questions about the reservation'
  },
  'INPUT_HERE': {
    fi: 'Syötä tähän...',
    en: 'Type here...'
  },
  'EXTRAS': {
    fi: 'Lisäpalvelut',
    en: 'Extras'
  },
  'INCLUDED_IN_PRICE': {
    fi: 'Sisältyy hintaan',
    en: 'Included in price'
  },
  'ADDITIONAL_INFO_HERE': {
    fi: 'Lisätiedot tähän...',
    en: 'Type here...'
  },
  'TO_LOCATION_HOW': {
    fi: 'Kuljetus',
    en: 'Transfer'
  },
  'TRANSPORTATION': {
    fi: 'Kuljetus',
    en: 'Pick-up'
  },
  'DO_YOU_WANT_TRANSPORTATION': {
    fi: 'Haluatko kuljetuksen koko ryhmälle?',
    en: 'Do you want transportation for the whole group?'
  },
  'CHOOSE_A_PICK_UP_LOCATION': {
    fi: 'Valitse noutopaikka',
    en: 'Select a place where you want to be picked up'
  },
  'CHOOSE_A_DROP_OFF_LOCATION': {
    fi: 'Valitse vientipaikka',
    en: 'Choose a drop-off location'
  },
  'LEAVING_HOW': {
    fi: 'Paluukyyti',
    en: 'Drop-off'
  },
  'CHOOSE': {
    fi: 'Valitse',
    en: 'Choose'
  },
  'LANGUAGE': {
    fi: 'kieli',
    en: 'language'
  },
  'AN_OPTION': {
    fi: 'vaihtoehto',
    en: 'an option'
  },
  'YES': {
    fi: 'Kyllä',
    en: 'Yes'
  },
  'NO': {
    fi: 'Ei',
    en: 'No'
  },
  'CONTACT_INFORMATION': {
    fi: 'Yhteystiedot',
    en: 'Contact information'
  },
  'CONTACT_PERSON_DETAILS': {
    fi: 'Yhteyshenkilön tiedot',
    en: 'Contact person details'
  },
  'CONTACT_PERSON': {
    fi: 'Yhteyshenkilö',
    en: 'Contact person'
  },
  'PAYMENT': {
    fi: 'Maksu',
    en: 'Payment'
  },
  'PAYTRAIL': {
    fi: 'Paytrail',
    en: 'Paytrail'
  },
  'WHEN_YOU_PRESS_YOU_WILL_GO_TO_PAYTRAIL': {
    fi: 'Painaessasi maksutapaa siirryt Paytrailiin maksamaan tilauksen',
    en: 'When you press a payment options you will be redicted to Paytrail for payment'
  },
  'CONTINUE': {
    fi: 'Jatka',
    en: 'Continue'
  },
  '1_QUESTIONS': {
    fi: '1. Kysymykset ja lisäpalvelut',
    en: '1. Questions and extras'
  },
  '2_CONTACT_PERSON': {
    fi: '2. Yhteyshenkilö',
    en: '2. Contact person'
  },
  '3_PAYMENT': {
    fi: '3. Maksu',
    en: '3. Payment'
  },
  'SHOPPING_CART_SUMMARY': {
    fi: 'Varauksen yhteenveto',
    en: 'Reservation summary'
  },
  'FILL_ALL_REQUIRED_FIELDS': {
    fi: '* Täytä pakolliset kentät / Korjaa virheet',
    en: '* Fill all required fields / Fix errors'
  },
  'CHOOSE_A_LANGUAGE': {
    fi: 'Valitse kieli',
    en: 'Choose a language'
  },
  'CHECKOUT': {
    fi: 'Kassa',
    en: 'Checkout'
  },
  'RELOAD': {
    fi: 'Lataa uudestaan',
    en: 'Reload'
  },
  'IN_TOTAL': {
    fi: 'Yhteensä',
    en: 'Total'
  },
  'INCLUDING_TAXES': {
    fi: 'Sisältää veroa',
    en: 'Includes tax'
  },
  'PARTICIPANTS_IN_CART': {
    fi: 'Osallistujat',
    en: 'Participants'
  },
  'DEMANDING': {
    fi: 'Haastava',
    en: 'Demanding'
  },
  'PAY': {
    fi: 'Maksa',
    en: 'Pay'
  },
  'SOMETHING_HAPPENED': {
    fi: 'Valitettavasti tuotteen ennakkovaraaminen epäonnistui.',
    en: 'Unfortunately prebooking of the product failed.'
  },
  'PARTICIPANTS_CHECKOUT': {
    fi: 'Osallistujat',
    en: 'Participants'
  },
  'CLOSE_PARTICIPANT': {
    fi: 'Sulje',
    en: 'Close'
  },
  'OPEN_PARTICIPANT': {
    fi: 'Avaa',
    en: 'Open'
  },
  'DAY_TOUR_OR_ACTIVITY': {
    fi: 'Päiväretki / aktiviteetti',
    en: 'Day tour / activity'
  },
  'FAMILY_FRIENDLY': {
    fi: 'Perheille sopiva',
    en: 'Family friendly'
  },
  'GROUP_FRIENDLY': {
    fi: 'Ryhmille sopiva',
    en: 'Group friendly'
  },
  'ADVENTURE': {
    fi: 'Seikkailu',
    en: 'Adventure'
  },
  'SAFARI_AND_WILDLIFE': {
    fi: 'Safari ja Villieläimet',
    en: 'Safari ja Wildlife'
  },
  'fi': {
    fi: 'Suomi',
    en: 'Finnish'
  },
  'en': {
    fi: 'Englanti',
    en: 'English'
  },
  'fr': {
    fi: 'Ranska',
    en: 'French'
  },
  'ru': {
    fi: 'Venäjä',
    en: 'Russian'
  },
  'OUTDOOR': {
    fi: 'Ulkoilma',
    en: 'Outdoor'
  },
  'DAY_TRIPS_AND_EXCURSIONS': {
    fi: 'Päivämatkat ja -retket',
    en: 'Day trips and excursions'
  },
  'ADRENALINE_AND_EXTREME': {
    fi: 'Adrenaliini ja extreme',
    en: 'Adrenaline and extreme'
  },
  'SELF_DRIVE_TOUR': {
    fi: 'Itseajokierros',
    en: 'Self drive tour'
  },
  'ECO_FRIENDLY': {
    fi: 'Ympäristöystävällinen',
    en: 'Eco friendly'
  },
  'SENIOR': {
    fi: 'Eläkeläinen',
    en: 'Senior'
  },
  'YOUTH': {
    fi: 'Nuoriso',
    en: 'Youth'
  },
  'WALKING_TOUR': {
    fi: 'Kävelyretki',
    en: 'Walking tour'
  },
  'PHOTOGRAPHY': {
    fi: 'Valokuvaus',
    en: 'Photography'
  },
  'EDUCATIONAL_TOUR': {
    fi: 'Opetuskierros',
    en: 'Educational tour'
  },
  'COUPLES': {
    fi: 'Pariskunnat',
    en: 'Couples'
  },
  'NATURE': {
    fi: 'Luonto',
    en: 'Nature'
  },
  'ROMANTIC': {
    fi: 'Romantiikka',
    en: 'Romantic'
  },
  'CULTURAL_AND_THEME_TOURS': {
    fi: 'Kulttuuri- ja teemamatkat',
    en: 'Cultural and theme tours'
  },
  'PARTICIPANT_EXTRAS': {
    fi: 'Osallistujan lisäpalvelut',
    en: 'Extras per participant'
  },
  'PARKING_FEES': {
    fi: 'Pysäköintimaksut',
    en: 'Parking fees'
  },
  'FOOD_AND_DRINKS': {
    fi: 'Ruoka ja juoma',
    en: 'Food and Drinks'
  },
  'WIFI': {
    fi: 'Wifi',
    en: 'Wifi'
  },
  'GOODS_AND_SERVICES_TAX': {
    fi: 'Tavara- ja palveluvero',
    en: 'Goods and services tax'
  },
  'FUEL_SURCHARGE': {
    fi: 'Ylimääräinen polttoainemaksu',
    en: 'Fuel surcharge'
  },
  'TIP_OR_GRATUITY': {
    fi: 'Juomaraha tai palvelumaksu',
    en: 'Tip or gratuity'
  },
  'REQUIRES_AT_LEAST_PARTICIPANTS_1': {
    fi: 'Vaatii vähintään',
    en: 'Requires at least'
  },
  'REQUIRES_AT_LEAST_PARTICIPANTS_2': {
    fi: 'osallistujaa',
    en: 'participants'
  },
  'DAYS': {
    fi: 'päivää',
    en: 'days'
  },
  'HOURS': {
    fi: 'tuntia',
    en: 'hours'
  },
  'MINUTES': {
    fi: 'minuuttia',
    en: 'minutes'
  },
  'DAY': {
    fi: 'päivä',
    en: 'day'
  },
  'HOUR': {
    fi: 'tunti',
    en: 'hour'
  },
  'MINUTE': {
    fi: 'minuutti',
    en: 'minute'
  },
  'ALL_TOGETHER': {
    fi: 'Kaikki yhteen',
    en: 'Without spaces'
  },
  'PARTICIPANT': {
    fi: 'Osallistuja',
    en: 'Participant'
  },
  'EMAIL': {
    fi: 'Sähköposti',
    en: 'Email'
  },
  'BIRTHDAY': {
    fi: 'Syntymäaika',
    en: 'Day of Birth'
  },
  'FIRST_NAME': {
    fi: 'Etunimi',
    en: 'First name'
  },
  'LAST_NAME': {
    fi: 'Sukunimi',
    en: 'Last name'
  },
  'PHONE_NUMBER': {
    fi: 'Puhelinnumero',
    en: 'Phone number'
  },
  'RESERVATION_-': {
    fi: 'Varaus -',
    en: 'Reservation -'
  },
  'RESERVATION': {
    fi: 'Varaus',
    en: 'Reservation'
  },
  'EXTRA': {
    fi: 'Lisäpalvelu',
    en: 'Extra'
  },
  'PICKUP': {
    fi: 'Siirtyminen',
    en: 'Pick-up'
  },
  'QUESTIONS': {
    fi: 'Kysymyksiä',
    en: 'Questions'
  },
  'PAYMENT_FAILURE_MESSAGE': {
    fi: 'Maksutapahtuma keskeytettiin. Varausta ei tehty.',
    en: 'Payment was cancelled. Reservation was not made.'
  },
  'THANK_YOU_FOR_RESERVATION': {
    fi: 'Kiitos varauksesta!',
    en: 'Thank you for the reservation!'
  },
  'PARTICIPANTS_THANK_YOU_PAGE': {
    fi: 'Osallistujat',
    en: 'Participants'
  },
  'SELECT_PAYMENT_METHOD': {
    fi: 'Valitse maksutapa:',
    en: 'Select a payment method:'
  },
  'RESERVATION_NUMBER': {
    fi: 'Varausnumero',
    en: 'Reservation ID'
  },
  'ADDITIONALS': {
    fi: 'Lisäpalvelut',
    en: 'Extra Services'
  },
  'PICK_UP': {
    fi: 'Kuljetus',
    en: 'Pick-up'
  },
  'DROP_OFF': {
    fi: 'Paluukyyti',
    en: 'Drop-off'
  },
  'CHOOSE_A_PICK_UP_PLACE': {
    fi: 'Valitse noutopaikka',
    en: 'Choose a pick-up location'
  },
  'CHOOSE_A_DROP_OFF_PLACE': {
    fi: 'Valitse vientipaikka',
    en: 'Choose a drop-off location'
  },
  'SELECT_PARTICIPANTS_TO_SEE_AVAILIBILITIES': {
    fi: 'Valitse osallistujia nähdäksesi vapaita aikoja',
    en: 'Choose participants to see the available times'
  },
  'ADULTS_ONLY': {
    fi: 'Vain aikuisille',
    en: 'Adults only'
  },
  'SNOWMOBILE_TOUR': {
    fi: 'Moottorikelkkaretki',
    en: 'Snowmobile tour'
  },
  'HORSEBACK_RIDING': {
    fi: 'Ratsastus',
    en: 'Horseback riding'
  },
  'NO_ADDITIONAL_QUESTIONS_ABOUT_THE_RESERVATION': {
    fi: 'Ei kysymyksiä varauksesta',
    en: 'No questions about the reservation'
  },
  'ARTS_AND_CULTURE': {
    fi: 'Taide ja kulttuuri',
    en: 'Arts and culture'
  },
  'HIKING': {
    fi: 'Vaellus',
    en: 'Hiking'
  },
  'TAILOR_MADE': {
    fi: 'Erikseen suunniteltu',
    en: 'Tailor made'
  },
  'LUXURY': {
    fi: 'Luksus',
    en: 'Luxury'
  },
  'CITY_BREAK': {
    fi: 'Tauko kaupunkielämästä',
    en: 'City break'
  },
  'LUXURY_AND_SPECIAL_OCCASIONS': {
    fi: 'Luksus ja erikoistapahtuma',
    en: 'Luxury and special occasions'
  },
  'VIP_AND_EXCLUSIVE': {
    fi: 'Vip ja erityisvieraille',
    en: 'Vip and exclusive'
  },
  'NIGHTLIFE': {
    fi: 'Yöelämä',
    en: 'Nightlife'
  },
  'HOLIDAY_AND_SEASONAL_TOURS': {
    fi: 'Loma ja kausikohtainen kierros',
    en: 'Holiday and seasonal tours'
  },
  'CHALLENGING': {
    fi: 'Haastava',
    en: 'Challenging'
  },
  'PRIVATE_ACTIVITY': {
    fi: 'Yksityinen',
    en: 'Private activity'
  },
  'SKIING': {
    fi: 'Hiihto',
    en: 'Skiing'
  },
  'VERY_EASY': {
    fi: 'Todella helppo',
    en: 'Very easy'
  },
  'CULINARY': {
    fi: 'Ruokaharrastajille',
    en: 'Culinary'
  },
  'SIGHTSEEING_ATTRACTION': {
    fi: 'Näköala',
    en: 'Sightseeing attraction'
  },
  'ENTRY_OR_ADMISSION_FEE': {
    fi: 'Sisäänpääsy-/Osallistumismaksu',
    en: 'Entry or admission fee'
  },
  'BIKE_TOUR': {
    fi: 'Pyöräretki',
    en: 'Bike tour'
  },
  'RAINY_DAY': {
    fi: 'Sadepäivä',
    en: 'Rainy day'
  },
  'SPA_AND_WELLNESS': {
    fi: 'Kylpylä ja hyvinvointi',
    en: 'Spa and wellness'
  },
  'COULDNT_LOAD_CALENDER': {
    fi: 'Kalenteria ei pystytty lataamaan',
    en: "Couldn't load calender"
  },
  'ADD': {
    fi: 'Lisää',
    en: 'Select'
  },
  'REMOVE': {
    fi: 'Poista',
    en: 'Remove'
  },
  'REQUIRED': {
    fi: 'Pakollinen',
    en: 'Required'
  },
  'CHOOSE_AMOUNT': {
    fi: 'Valitse määrä',
    en: 'Choose amount'
  },
  'BE_READY_PICKUP_PART_1': {
    fi: 'Olethan valmis',
    en: 'Be ready to be picked up'
  },
  'BE_READY_PICKUP_PART_2': {
    fi: 'minuuttia ennen aktiviteetin alkua',
    en: 'minutes before the activity starts'
  },
  'TERMS_AND_CONDITIONS_1': {
    fi: 'Hyväksyn',
    en: 'I agree to the'
  },
  'TERMS_AND_CONDITIONS_2': {
    fi: 'ja',
    en: 'and'
  },
  'TERMS': {
    fi: 'käyttöehdot',
    en: 'terms of use'
  },
  'CANCELLATION_POLICY': {
    fi: 'varausehdot',
    en: 'booking conditions'
  },
  'RESERVATION_STEPS': {
    fi: 'Varauksen vaiheet',
    en: 'Reservation order'
  },
  'AMOUNT': {
    fi: 'Määrä',
    en: 'Amount'
  },
  'VIEW_PHOTOS': {
    fi: 'Katso kuvat',
    en: 'View photos'
  },
  'BRING_FROM_PARTIPANT_1': {
    fi: 'Tuo Osallistuja 1 - tiedot',
    en: 'Bring Participant 1 - information'
  },
  'CONTACT_PERSON_IS_SAME_AS_PARTICIPANT_1': {
    fi: 'Ensimmäinen osallistuja on yhteyshenkilö',
    en: 'Use first participant for contact details'
  },
  'ADDITIONAL_QUESTIONS': {
    fi: 'Ylimääräiset kysymykset',
    en: 'Additional Questions'
  },
  'ISO': {
    fi: 'Maa',
    en: 'Country'
  },
  'ONLY_AVAILABLE_BY_REQUEST_1': {
    fi: 'Tämä elämys on varattavana vain pyynnöstä. Elämyksen järjestäjä vastaa pyyntöön ajassa: ',
    en: 'This activity is only available by request. The organiser will answer a request in: '
  },
  'READ_BEFORE_CONTINUE': {
    fi: 'Lue ennen jatkamista',
    en: 'Read before you continue'  
  },
  'BOOK_NOW': {
    fi: 'Varaa nyt',
    en: 'Book now'
  },
  'BIRDWATCHING': {
    fi: 'Lintujen tarkkailu',
    en: 'Birdwatching'
  },
  'MINI_CRUISE': {
    fi: 'Pienoisristeily',
    en: 'Mini cruise'
  },
  'SAILING_OR_BOAT_TRIP': {
    fi: 'Purjehtiminen/veneretki',
    en: 'Sailing or boat trip'
  },
  'Not a valid phone number': {
    fi: 'Puhelinnumero ei ole oikeaa muotoa',
    en: 'Not a valid phone number'
  }
}